import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-error500',
  templateUrl: './error500.component.html',
  styleUrls: ['./error500.component.scss']
})
export class Error500Component implements OnInit {

  faGlobe = faGlobe;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(['home']);
    }, 3500);
  }

}
